import "../datepicker/datepicker.css";
import "./style.css";
import {SearchFormProps} from "./SearchForm.props";
import React, {useEffect, useState} from "react";
import {OptionType} from "./constants/Option.type";
import Arrow from "../../../assets/images/search/filter-arrow.svg";
import {Option} from "./Option";
import {ko} from "date-fns/esm/locale";
import DatePicker from "react-datepicker";
import {getLimitDate} from "../../../util/DatePickerUtil";

export default function SearchForm(props: SearchFormProps) {
    const [visibleOptionIndex, setVisibleOptionIndex] = useState<number>(-1);
    const [options, setOptions] = useState<Option[]>(props.options);

    useEffect(() => {
        setOptions(props.options);
    }, []);


    const search = (): void => {
        props.onSearch();
    }

    const getListExceptByIndex = (originList: any[], exceptedIndex: number): any[] => {
        return originList.filter((value, index) => index !== exceptedIndex);
    }

    const toggleOptionListVisible = (index: number): void => {
        if (visibleOptionIndex === index) {
            setVisibleOptionIndex(-1);
        } else {
            setVisibleOptionIndex(index);
        }
    }

    const changeTypeValue = (option: Option, typeIndex: number): void => {
        const selectedType = option.list.filter((value, index) => index !== option.value)[typeIndex];
        const updatedOption = ({
            ...option,
            value: selectedType
        });

        updateOption(updatedOption);
        setVisibleOptionIndex(-1);
    }

    const changeCheckValue = (option: Option, checkIndex: number): void => {
        const updatedOption = ({
            ...option,
            value: [...option.value]
        });

        updatedOption.value[checkIndex] = !updatedOption.value[checkIndex];

        updateOption(updatedOption);
    }

    const changeType = (option: Option, typeIndex: number): void => {
        const updatedOption = ({
            ...option,
            value: {
                ...option.value,
                type: getListExceptByIndex(option.list, option.value.type)[typeIndex]
            }
        });

        updateOption(updatedOption);
        setVisibleOptionIndex(-1)
    }

    const changeTextValue = (option: Option, event: React.ChangeEvent<HTMLInputElement>): void => {
        const updatedOption = {...option};

        if (option.type === OptionType.TYPE_TEXT) {
            updatedOption.value.text = event.target.value;
        } else if (option.type === OptionType.TEXT) {
            updatedOption.value = event.target.value;
        }

        updateOption(updatedOption);
    }

    const changeDate = (option: Option, date: Date | null, isStartDate: boolean): void => {
        const updatedOption = {...option};

        if (isStartDate) {
            updatedOption.value.startDate = date;
        } else {
            updatedOption.value.endDate = date;
        }

        updateOption(updatedOption);
    }

    const updateOption = (updatedOption: Option): void => {
        const updatedOptions = options.map((value) => {
            if (value.key === updatedOption.key) {
                return updatedOption;
            }

            return value;
        });

        setOptions(updatedOptions);
        props.onUpdate(updatedOptions);
    }

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === "Enter") {
            search();
        }
    }

    return (
        <div className="common list-search-wrapper">
            <div className="filter-section">
                {
                    options.map((option, index) => {
                        return (
                            <div key={index} className="filter-state-wrapper">
                                <div className="title">
                                    {option.name}
                                </div>
                                {
                                    option.type === OptionType.CHECK_LIST && (
                                        <div className="filter-state-content">
                                            {
                                                option.stringList.map((label, index) => {
                                                    return (
                                                        <div key={index} className="filter-check">
                                                            <input
                                                                onChange={() => changeCheckValue(option, index)}
                                                                checked={option.value[index]}
                                                                type="checkbox"
                                                                data-testid="checkBox"
                                                            />
                                                            <div className="text">
                                                                {label}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    )
                                }
                                {
                                    option.type === OptionType.TYPE_TEXT && (
                                        <div className="filter-search-content">
                                            <div className="filter-search-wrapper">
                                                <div className="search-filter open-filter">
                                                    <div onClick={() => toggleOptionListVisible(index)} className="filter-box">
                                                        <div className="text">
                                                            {option.stringList[option.value.type]}
                                                        </div>
                                                        <img src={Arrow} alt="arrow"/>
                                                    </div>
                                                    {
                                                        visibleOptionIndex === index && getListExceptByIndex(option.stringList, option.value.type).map(
                                                            (type, index) => {
                                                                return (
                                                                    <div key={index} onClick={() => changeType(option, index)} className="filter-box">
                                                                        <div className="text">
                                                                            {type}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <input
                                                onChange={(event) => changeTextValue(option, event)}
                                                onKeyUp={handleKeyUp}
                                                className="search-input"
                                                placeholder="검색어 입력"
                                                defaultValue={option.value.text}
                                                type="text"
                                            />
                                        </div>
                                    )
                                }
                                {
                                    option.type === OptionType.TYPE && (
                                        <div className="search-filter">
                                            <button onClick={() => toggleOptionListVisible(index)} className="filter-box">
                                                <div className="text">
                                                    {option.stringList[option.value]}
                                                </div>
                                                <img src={Arrow} alt="arrow"/>
                                            </button>
                                            {
                                                visibleOptionIndex === index && getListExceptByIndex(option.stringList, option.value).map(
                                                    (type, typeIndex) => {
                                                        return (
                                                            <button key={typeIndex} onClick={() => changeTypeValue(option, typeIndex)} className="filter-box">
                                                                <div className="text">
                                                                    {type}
                                                                </div>
                                                            </button>
                                                        );
                                                    }
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    option.type === OptionType.DATE && (
                                        <>
                                            <div className="filter-date-content">

                                                <DatePicker
                                                    className="date-picker"
                                                    name="expiredDate"
                                                    dateFormat="yyyy-MM-dd"
                                                    selected={option.value.startDate ? new Date(option.value.startDate) : null}
                                                    maxDate={getLimitDate(option.value.startDate, option.value.endDate, true)}
                                                    locale={ko}
                                                    data-testid="expired-date"
                                                    onChange={(date) => {changeDate(option, date, true)}}
                                                    autoComplete="off"
                                                />
                                                <DatePicker
                                                    className="date-picker"
                                                    name="expiredDate"
                                                    selected={option.value.endDate ? new Date(option.value.endDate) : null}
                                                    dateFormat="yyyy-MM-dd"
                                                    minDate={getLimitDate(option.value.startDate, option.value.endDate, false)}
                                                    locale={ko}
                                                    data-testid="expired-date"
                                                    onChange={(date) => {changeDate(option, date, false)}}
                                                    autoComplete="off"
                                                />
                                            </div>
                                            <div className="etc">
                                                ~
                                            </div>
                                        </>
                                    )
                                }
                                {
                                    option.type === OptionType.TEXT && (
                                        <div className="filter-search-content">
                                            <input type="text"
                                                   onChange={(event) => changeTextValue(option, event)}
                                                   onKeyUp={handleKeyUp}
                                                   defaultValue={option.value}
                                                   className="search-input"
                                                   placeholder="검색어 입력"
                                                   data-testid="keyword"
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        );
                    })
                }
            </div>
            <button onClick={() => search()} className="search-button">
                검색
            </button>
        </div>
    );
}